import { useInfiniteQuery } from "@tanstack/react-query";

import { getNotificationsByAccount } from "@/api/graphql/notifications/account/api.ts";
import { createGetNotificationsByAccountQueryOptions } from "@/api/graphql/notifications/account/queryOptions.ts";
import type { GetNotificationsByAccount } from "@/api/graphql/notifications/types.ts";

export const useGetNotificationsByAccount = ({
  pageSize,
  accountId,
}: GetNotificationsByAccount) => {
  const response = useInfiniteQuery(
    createGetNotificationsByAccountQueryOptions(
      { pageSize, accountId },
      getNotificationsByAccount,
    ),
  );

  return {
    ...response,
    totalNotifications: response.data?.pages[0]?.pagination.total || 0,
  };
};
